import React from "react";
import Navbar from "@pages/Site/components/Navbar";
import HeroSection from "@pages/Site/components/HeroSection";
import FeaturesOverviewSection from "@pages/Site/components/FeaturesOverviewSection";
import GetInTouch from "@pages/Site/components/GetInTouch";
import ScrollProgressBar from "@pages/Site/components/ScrollProgressBar";
import { useScrollSections } from "@pages/Site/utils/useScrollSections";
import SectionPrice from "./components/SectionPrice";
import MissionStatementSection from "./components/MissionStatementSection";
import TakeTheTour from "./components/TakeTheTour";

const NAVBAR_HEIGHT = 72; // in px, adjust if your navbar height changes
const TOTAL_SECTIONS = 6; // Total number of sections in the site

const Site: React.FC = () => {
  const {
    scrollContainerRef,
    activeSection,
    scrollToSection,
    setActiveSection,
  } = useScrollSections(TOTAL_SECTIONS, NAVBAR_HEIGHT);

  const scrollToDemo = () => {
    scrollToSection(5);
  };

  return (
    <div className="relative md:h-screen md:overflow-hidden bg-[#EDF2FC]">
      <Navbar
        activeSection={activeSection}
        scrollToSection={scrollToSection}
        setActiveSection={setActiveSection}
      />
      <div
        ref={scrollContainerRef}
        className="2xl:h-[calc(100vh-96px)] h-[calc(100vh-75px)] overflow-y-scroll scroll-smooth scrollbar-hide bg-[#EDF2FC] overscroll-y-none touch-pan-y"
      >
        <ScrollProgressBar
          currentSection={activeSection}
          totalSections={TOTAL_SECTIONS}
        />
        <div className="2xl:h-[calc(100vh-96px)] md:h-[calc(100vh-75px)] w-full section">
          <HeroSection onBookDemo={scrollToDemo} />
        </div>
        <div className="2xl:h-[calc(100vh-96px)] md:h-[calc(100vh-75px)] w-full section">
          <MissionStatementSection />
        </div>
        <div className="2xl:h-[calc(100vh-96px)] md:h-[calc(100vh-75px)] w-full section">
          <FeaturesOverviewSection />
        </div>
        <div className="2xl:h-[calc(100vh-96px)] md:h-[calc(100vh-75px)] w-full section bg-[#fff]">
          <TakeTheTour />
        </div>
        <div className="2xl:h-[calc(100vh-96px)] w-full section">
          <SectionPrice onBookDemo={scrollToDemo} />
        </div>
        <div className="2xl:h-[calc(100vh-96px)] md:h-[calc(100vh-75px)] w-full section">
          <GetInTouch />
        </div>
      </div>
    </div>
  );
};

export default Site;
